import Vue from 'vue'
import VueRouter from 'vue-router'
import Signin from '../pages/Signin.vue'
import SigninRls from '../pages/Signin.vue'
import Reminder from '../pages/Reminder.vue'
import Launcher from '../pages/Launcher.vue'
import EstimationAppRoutes from '@Estimation/EstimationAppRoutes'
import RequestPostAppRoutes from '@RequestPost/RequestPostAppRoutes'
import RequestPost from '@RequestPost/pages/RequestPost.vue'
import LogAppRoutes from '@log/LogAppRoutes'
import UserAppRoutes from '@User/UserAppRoutes'
import DepartmentAppRoutes from '@Department/DepartmentAppRoutes'
import PatrolAppRoutes from '@Patrol/PatrolAppRoutes'
import RoundCleanAppRoutes from '@RoundClean/RoundCleanAppRoutes'
import FixedCleanAppRoutes from '@FixedClean/FixedCleanAppRoutes'
import FacilityPatrolAppRoutes from '@FacilityPatrol/FacilityPatrolAppRoutes'
import PhotoReportAppRoutes from '@PhotoReport/PhotoReportAppRoutes'
import RlsAppRoutes from '@Rls/RlsAppRoutes'
import EvaluationAppRoutes from '@Evaluation/EvaluationAppRoutes'
import ContractInfoAppRoutes from '@ContractInfo/ContractInfoAppRoutes'
import InterviewsAppRoutes from '@Interviews/InterviewsAppRoutes'
import MasterAppRoutes from '@Master/MasterAppRoutes'
import AkbsAppRoutes from '@Akbs/AkbsAppRoutes'
import QualityReportAppRoutes from '@QualityReport/QualityReportAppRoutes'

import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'Signin',
    component: Signin,
    meta: { isPublic: true, title: 'RP - サインイン' }
  },
  {
    path: '/signinRls',
    name: 'SigninRls',
    component: SigninRls,
    meta: { isPublic: true, title: 'RP - サインイン' }
  },
  {
    path: '/reminder',
    name: 'Reminder',
    component: Reminder,
    meta: { isPublic: true, title: 'RP - パスワード再設定' }
  },
  {
    path: '/',
    name: 'Launcher',
    component: Launcher,
    meta: { requiresAuth: true, title: 'RP - メニュー' }
  },
  {
    path: '/customersRequestPost',
    name: 'customersRequestPost',
    component: RequestPost,
    meta: { isPublic: true, title: 'RP - お客様メインタスク' }
  },
  {
    ...EstimationAppRoutes
  },
  {
    ...RequestPostAppRoutes
  },
  {
    ...LogAppRoutes
  },
  {
    ...UserAppRoutes
  },
  {
    ...DepartmentAppRoutes
  },
  {
    ...PatrolAppRoutes
  },
  {
    ...RoundCleanAppRoutes
  },
  {
    ...FixedCleanAppRoutes
  },
  {
    ...FacilityPatrolAppRoutes
  },
  {
    ...PhotoReportAppRoutes
  },
  {
    ...EvaluationAppRoutes
  },
  {
    ...ContractInfoAppRoutes
  },
  {
    ...MasterAppRoutes
  },
  {
    ...RlsAppRoutes
  },
  {
    ...InterviewsAppRoutes
  },
  {
    ...AkbsAppRoutes
  },
  {
    ...QualityReportAppRoutes
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isSignin) {
    next({ path: '/signin', query: { redirect: to.fullPath } });
  } else {
    next();
  }
})

router.afterEach((to) => {
  document.title = to.meta.title || 'apollo-RP'

  const targetPages = [
    // メイン一覧、サブ知覧、カレンダー
    '/RequestPostList', '/RequestPostProgressList', '/TaskCalendar',
    // 写真報告関連
    '/PhotoReport', '/PhotoReportList',
    // 巡回 予定一覧
    '/ScheduleListByStaff', '/RoundScheduleListByStaff', '/FixedScheduleListByStaff', '/FacilityScheduleListByStaff',
    // 巡回 未点検一覧
    '/UnPatrolList', '/ClaimUnPatrolList', '/RoundUnPatrolList', '/FixedUnPatrolList', '/FacilityUnPatrolList',
    // 巡回 完了一覧
    '/CheckList', '/ClaimCheckList', '/RoundCheckList', '/FixedCheckList', '/FacilityCheckList',
    // RLS関連
    // '/RlsForm',
    '/RlsOperation', '/RlsMaster',
    // 巡回報告書
    // '/RoundCheckListTable',
    // 見積り
    '/EstimateList',
    // 評価シート関連
    '/EvaluationInput', '/EvaluationList', '/EnvReportList', '/EnvReportCounting', '/EnvReportItemSetting', '/StudyPolicy', '/StudyPolicyList', '/Organization', '/EvaluationMovieMaster', '/UnlockSetting', '/BossAverage', '/DailyReportList', '/Accompany',
    // 賞与関連
    '/BonusList',
    // 契約情報
    '/ContractMap', '/SiteOutline', '/SiteOutlineEdit',
    // AKBS関連（登録済み一覧はスマホでも PC と同じ見た目。出力画面はスマホ用の契約書返送タブがあるので入れない）
    '/AkbsRegisteredList',
    // クオリティレポート（予定・結果はスマホでも PC と同じ見た目。実施・報告書はスマホ用なので入れない）
    '/QualityReportSchedule'
  ]
  let isTargetPage = false
  for (let i = 0; i < targetPages.length; i++) {
    const t = targetPages[i]
    if (to.path.indexOf(t) >= 0) {
      isTargetPage = true
      // console.log(to.path)
      break
    }
  }
  if (isTargetPage) {
    document.querySelector("meta[name='viewport']").setAttribute('content', '')
  } else {
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=device-width')
  }
})

export default router
